import Hero from "../shared/Hero"; 
import { IoChevronForwardOutline } from "react-icons/io5";
import { BsArrowRightShort } from "react-icons/bs";

export default function LandingHero() {
  return (
    <Hero
      className="mt-[125px] font-poppins"
      title="Careers at VerdeMobility"
      description="We’re building India’s next-generation EV charging ecosystem—designed to be reliable, intelligent, safe, and sustainable. Join us in creating technology that moves people, businesses, and the future forward."
    >
      {/* <a href="#openings" className="btn-brand">View Open Roles</a> */}
         <a href="#openings"  className='text-gray-600'>
          <button
                                  className='btnWhite font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6 font-poppins'
                                >
                                  <span className="flex justify-center items-center">
                                    <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                                    <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                                  </span>
                                  View Open Roles
                                </button>
          </a>
      {/* <a href="#resume-cta" className="btn-vm-morph btn-vm-morph-light">

        <span className="morph-icon"><ArrowRight size={16} /></span>
        <span>Submit Your Resume</span>
      </a> */}
      <a href="#resume-cta" target="_blank" className='text-gray-600'>
          <button
                                  className='btnWhite font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6 font-poppins'
                                >
                                  <span className="flex justify-center items-center">
                                    <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                                    <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                                  </span>
                                  Submit Your Resume
                                </button>
          </a>
    </Hero>
  );
}
